<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_iii"></a><strong>John D. Caputo, <em>series editor</em></strong></p>
<p class="image1"><img alt="image" src="images/pub1.jpg"/><a id="page_iv"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// joh.vue?007f98b4